/**
 * Test helper for HTTP nocks
 * @module test/nock
 */
import { stringify } from '../services/query-string/index'

/**
 * @param {Object} query The request object
 * @returns {String} The object converted to a query string
 */
// eslint-disable-next-line import/prefer-default-export
export function stringifyQuery (query, options) {
  return stringify(query, options)
}
